var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('img',{attrs:{"src":"/logo.png"}}),_c('h1',[_vm._v("Spotify album extract")]),_c('p',[_vm._v("Select a playlist and get the full album from each track.")]),_c('b-button',{attrs:{"type":"is-primary is-rounded"},on:{"click":_vm.auth}},[_vm._v(" Load your playlists ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }